import { constant } from "./PricingActionConstants";
let initialState = {
    getSubscriptionPlansInProgress:false
}

export const PricingReducer = (state = initialState  , action ) =>{
    switch(action.type){
        case constant.GET_SUBSCIPTION_PLANS_IN_PROGRESS:
            return{...state , getSubscriptionPlansInProgress:true};
        case constant.GET_SUBSCIPTION_PLANS_COMPLETE:
            return{...state , getSubscriptionPlansInProgress:false ,subscriptionPlans:action.data}
        default :
            return state
    }
}
  
export default PricingReducer;